const formatAmount = (amount) => parseFloat(amount).toFixed(2);

export default formatAmount;
